import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'

//util
import { cache } from '@/util'

@Component({
  components: {},
})
export default class UserNode extends Vue {
  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  @Prop({ type: Object }) item!: UserItemEx

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  avatar = {
    url: '',
    loading: false,
  }

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: C O M P U T E D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  get extensionNumber() {
    return this.item.officeTel?.length === 4 ? this.item.officeTel : null
  }

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  getImage(email?: string) {
    if (email && email.indexOf('/') == -1) {
      this.avatar.loading = true
      cache.avatar.get(email).then((url: string) => {
        this.avatar.url = url
        this.avatar.loading = false
      })
    }
  }

  error(e: Event) {
    var elem = e.srcElement as HTMLImageElement
    elem.src = '/cm/gres/v1/img/ghost_loading.png'
  }

  errorGhost(e: Event) {
    var elem = e.srcElement as HTMLImageElement
    elem.src = '/cm/gres/faux/images/ghost.png'
  }

  gotoDetail() {
    this.$emit('detail', this.item)
  }

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: W A T C H : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y L E : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  created() {
    this.getImage(this.item.email)
  }
}
